import React from "react";
import { Reveal } from "../shared/Primitives";
import { ReserveDialog } from "../ReserveDialog";
import { Blob, Sparkle } from "../shared/Decor";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const FinalCta = () => (
  <section data-testid="final-cta-section" className="relative overflow-hidden bg-cocoa py-16 sm:py-24">
    <Blob className="absolute -top-24 -left-24 w-80 text-linen/10" />
    <Blob className="absolute -bottom-28 -right-20 w-80 text-espresso/30" />
    <Sparkle className="absolute top-16 right-16 w-9 text-linen/25 hidden sm:block" />
    <div className="max-w-4xl mx-auto px-6 sm:px-12 text-center flex flex-col items-center relative z-10">
      <Reveal>
        <h2 className="font-display font-semibold text-4xl sm:text-5xl lg:text-6xl tracking-tight text-linen leading-tight">
          Tu lugar en la comunidad te espera
        </h2>
      </Reveal>
      <Reveal delay={0.08}>
        <p className="mt-6 text-lg sm:text-xl font-light text-linen/80 max-w-2xl leading-relaxed">
          Aparta tu habitación hoy y múdate a un espacio listo para vivir, trabajar y conectar.
        </p>
      </Reveal>
      <Reveal delay={0.16}>
        <div className="mt-10 flex justify-center">
          <ReserveDialog>
            <button
              data-testid="cta-reserve-btn"
              className="rounded-full bg-linen text-cocoa px-8 py-4 text-sm font-bold tracking-wide uppercase hover:bg-khaki transition-colors duration-300"
            >
              Apartar habitación
            </button>
          </ReserveDialog>
        </div>
      </Reveal>
    </div>
  </section>
);
